import { environment } from '../../../environments/environment';
import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

@Pipe({
  name: 'fullTime'
})
export class FullTimePipe implements PipeTransform {

  transform(value?: string | number | Date): unknown {
    if (!value) return value;

    const isHours12 = environment.isHours12;

    const date = moment(value);

    return date.format(`${isHours12 ? 'hh:mm A' : 'HH:mm'}`);
  }

}